import http from "@/http-common";

const BASE_URL = "/identify-ai";

class IdentifyAIService {
    checkInformationRecognition(id, date){
        return http.get(BASE_URL + `/check-info-attendance-ai`, {params:{id, date}});
    }
}

export default new IdentifyAIService();